export default {
    cache : {},
    events : {},
    promises : {},
    states : {},
}
